
import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { useMagicKeys, onClickOutside } from '@vueuse/core';

export default defineComponent({
  props: {
    timer: {
      type: Number,
      default: 5000,
    },
  },

  setup(props, { emit }) {
    const { escape } = useMagicKeys();
    const isOpen = ref(false);
    const timeout = ref();
    const notificationText = ref();

    const close = () => {
      if (!isOpen.value) return;
      isOpen.value = false;
      emit('closed');
    };

    const open = (text) => {
      if (isOpen.value) return;
      notificationText.value = text;
      isOpen.value = true;
      timeout.value = setTimeout(() => {
        close();
      }, props.timer);
    };

    watch(escape, (v) => {
      if (!v) return;
      if (isOpen.value) return;
      clearTimeout(timeout.value);
      close();
    });

    const notificationRef = ref(null);
    onClickOutside(notificationRef, () => close());

    return {
      notificationText,
      close,
      open,
      notificationRef,
      isOpen,
    };
  },
});
